import React from 'react'
import AddNewCertification from '../components/Certification/add certification/AddNewCertification'

const AddNewCertificationPage = () => {
  return (
    <div>
        <AddNewCertification/>
    </div>
  )
}

export default AddNewCertificationPage
